import WorldImage from '../../portfolio-item/PortfolioItemFields/FieldRenderer/TypeSpecificFieldRenderers/WorldSelect/WorldImage';
import { type AgoraWorld } from '../../portfolio-item/PortfolioItemFields/FieldRenderer/TypeSpecificFieldRenderers/WorldSelect/worlds';
import styled from '@emotion/styled';
import StyledPerspectiveIndicator from './CardPerspectiveIndicator/StyledIndicator';
import { Tooltip } from '@mui/material';
import { useIntl } from 'react-intl';

const StyledIndicator = styled(StyledPerspectiveIndicator)({
  img: {
    width: '100%',
    height: '100%',
  },
});

type WorldIndicatorProps = {
  world: AgoraWorld;
};

const WorldIndicator = ({ world }: WorldIndicatorProps) => {
  const intl = useIntl();

  // Passing the label as a string generates an appropriate aria-label which
  // is better for accessibility
  const worldLabel = intl.formatMessage({
    id: `portfolio.challenge.card.world_indicators.labels.${world}_world`,
  });

  return (
    <Tooltip title={worldLabel} arrow>
      <StyledIndicator>
        <WorldImage world={world} />
      </StyledIndicator>
    </Tooltip>
  );
};

export default WorldIndicator;
